import axios, { AxiosError } from "axios";
import { useQuery, UseQueryResult } from "react-query";
import { ClientsResponse } from "../model/Client";
import { ClientsRequest } from "../request/ClientsRequest";
import { HttpClientError } from "../../../../providers/HttpClient";

const ClientsApiService = async (
  request: ClientsRequest
): Promise<ClientsResponse> => {
  try {
    const { data } = await axios.get("/clients/", {
      params: {
        ...(request.page && { page: request.page }),
        ...(request.employer !== undefined && { employer: request.employer }),
      },
    });
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    const errorMessage = HttpClientError(axiosError);
    const customError = new Error(errorMessage);

    customError.cause = axiosError;
    throw customError;
  }
};

const useClientsApiService = (
  request: ClientsRequest
): UseQueryResult<ClientsResponse, Error | AxiosError> => {
  const { enabled = true, ...queryParams } = request;
  return useQuery<ClientsResponse, Error | AxiosError>(
    ["ClientsApiService", ...Object.values(queryParams)],
    () => ClientsApiService(queryParams),
    { keepPreviousData: true, enabled }
  );
};

export { ClientsApiService, useClientsApiService };
